const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export { BASE_URL };
